import { render, staticRenderFns } from "./language-selector-button.vue?vue&type=template&id=61d97478"
import script from "./language-selector-button.vue?vue&type=script&lang=ts"
export * from "./language-selector-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports